var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateAccountActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FDAB29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0285 25.4875C20.5671 25.4875 25.057 23.2425 25.057 20.4732C25.057 17.7039 20.5671 15.459 15.0285 15.459C9.48992 15.459 5 17.7039 5 20.4732C5 23.2425 9.48992 25.4875 15.0285 25.4875Z",
    fill: "#FDAB29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0297 25.1286C20.3705 25.1286 24.7001 23.044 24.7001 20.4725C24.7001 17.901 20.3705 15.8164 15.0297 15.8164C9.68894 15.8164 5.35938 17.901 5.35938 20.4725C5.35938 23.044 9.68894 25.1286 15.0297 25.1286Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0285 18.3265C18.9846 18.3265 22.1917 15.1194 22.1917 11.1632C22.1917 7.20709 18.9846 4 15.0285 4C11.0723 4 7.86523 7.20709 7.86523 11.1632C7.86523 15.1194 11.0723 18.3265 15.0285 18.3265Z",
    fill: "#FDAB29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0277 17.9676C18.7861 17.9676 21.8328 14.9208 21.8328 11.1625C21.8328 7.40415 18.7861 4.35742 15.0277 4.35742C11.2694 4.35742 8.22266 7.40415 8.22266 11.1625C8.22266 14.9208 11.2694 17.9676 15.0277 17.9676Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2143 21.15H18.25V19.25H21.2143H21.4643V19V16.25H23.5357V19V19.25H23.7857H26.75V21.15H23.7857H23.5357V21.4V24.75H21.4643V21.4V21.15H21.2143Z",
    fill: "#FFAD45",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccountActive);
export default __webpack_public_path__ + "static/media/create-account-active.dcbc7d6580807d72609e372803987aea.svg";
export { ForwardRef as ReactComponent };